// 5.1 Encoders and decoders
/** @const */
export var finished = -1;
//# sourceMappingURL=finished.js.map